/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_HorseInputs */

const en_val_horse = /** @type {(inputs: Val_HorseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horse`)
};

const es_val_horse = /** @type {(inputs: Val_HorseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caballo`)
};

const fr_val_horse = /** @type {(inputs: Val_HorseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheval`)
};

const de_val_horse = /** @type {(inputs: Val_HorseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pferd`)
};

const ja_val_horse = /** @type {(inputs: Val_HorseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`馬`)
};

const zh_val_horse = /** @type {(inputs: Val_HorseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`马`)
};

const ar_val_horse = /** @type {(inputs: Val_HorseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حصان`)
};

const id_val_horse = /** @type {(inputs: Val_HorseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuda`)
};

const it_val_horse = /** @type {(inputs: Val_HorseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cavallo`)
};

const ru_val_horse = /** @type {(inputs: Val_HorseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лошадь`)
};

const pt_val_horse = /** @type {(inputs: Val_HorseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cavalo`)
};

const ko_val_horse = /** @type {(inputs: Val_HorseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`말`)
};

/**
* | output |
* | --- |
* | "Horse" |
*
* @param {Val_HorseInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_horse = /** @type {((inputs?: Val_HorseInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_HorseInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_horse(inputs)
	if (locale === "es") return es_val_horse(inputs)
	if (locale === "fr") return fr_val_horse(inputs)
	if (locale === "de") return de_val_horse(inputs)
	if (locale === "ja") return ja_val_horse(inputs)
	if (locale === "zh") return zh_val_horse(inputs)
	if (locale === "ar") return ar_val_horse(inputs)
	if (locale === "id") return id_val_horse(inputs)
	if (locale === "it") return it_val_horse(inputs)
	if (locale === "ru") return ru_val_horse(inputs)
	if (locale === "pt") return pt_val_horse(inputs)
	return ko_val_horse(inputs)
});